import React, { useEffect, useState } from "react";
import { WalletController } from "../../controllers";
import { ForeignBankAccounts } from "../../pages";
import { toJS } from "mobx";
import { walletStore } from "../../stores";
import { observer } from "mobx-react";

const ForeignBankAccountsContainer = () => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchForeignBankAccounts = async () => {
      setLoading(true);
      await WalletController.getForeignBankAccounts();
      setLoading(false);
    };
    fetchForeignBankAccounts();
  }, []);

  return (
    <ForeignBankAccounts
      loading={loading}
      foreignBankAccounts={toJS(walletStore.foreignBankAccounts)}
    />
  );
};

export default observer(ForeignBankAccountsContainer);
